import { defineStore } from 'pinia'

import type { DisciplineProgressReportsStore } from './interfaces'

import { emptyDisciplineProgressReportsFilters } from '@helpers/discipline-progress-reports-query'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineProgressReportsStore = defineStore('discipline-progress-reports', {
  state: (): DisciplineProgressReportsStore => ({
    loading: false,
    reports: [],
    meta: null,
    filters: emptyDisciplineProgressReportsFilters(),
    currentPage: 1,
    perPage: 25,
    editingReport: null,
  }),
  actions,
  getters,
})
